module.exports = __webpack_public_path__ + "media/assets/images/hhheader_movimenta-6591b4e62f1a4150ba68c22c317522b9.svg";